import React from "react";
import CinematicHero from "@/components/home/CinematicHero";
import Marquee from "@/components/home/Marquee";
import BentoServices from "@/components/home/BentoServices";
import InteractiveHouse from "@/components/home/InteractiveHouse";
import ManifestoChapters from "@/components/home/ManifestoChapters";
import StatsSection from "@/components/home/StatsSection";
import BeforeAfter from "@/components/home/BeforeAfter";
import ProcessTimeline from "@/components/home/ProcessTimeline";
import Reviews from "@/components/home/Reviews";
import BrandsStrip from "@/components/home/BrandsStrip";
import FaqSection from "@/components/home/FaqSection";
import FinalCTA from "@/components/home/FinalCTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <CinematicHero />
      <Marquee />
      <BentoServices />
      <InteractiveHouse />
      <ManifestoChapters />
      <StatsSection />
      <BeforeAfter />
      <ProcessTimeline />
      <Reviews />
      <BrandsStrip />
      <FaqSection limit={8} />
      <FinalCTA />
    </div>
  );
}
